<template>
  <b-col md="6">
    <button
      :class="[
        'menu-card',
        'mb-4',
        { 'menu-card--shadowed': hasShadow, 'menu-card--with-hover-effect': hasHoverEffect },
      ]"
      @click="$emit('click')"
    >
      <p class="menu-card__title">{{ $t(title) }}</p>
      <p class="menu-card__description mb-0">{{ $t(description) }}</p>
    </button>
  </b-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    hasShadow: {
      type: Boolean,
      default: false,
    },
    hasHoverEffect: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.menu-card {
  width: 100%;
  background: white;
  text-align: left;
  padding: 20px;
  border: 1px solid rgba(235, 236, 239, 1);
  border-radius: 8px;

  &--shadowed {
    box-shadow: 0px 5px 15px 0px rgba(13, 68, 145, 0.08);
  }

  &--with-hover-effect {
    &:hover {
      background-color: #deeafc;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 8px;
    color: $mep-color-text-400;
  }
  &__description {
    color: $mep-color-text-400;
  }
}
</style>
